"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BREAKPOINTS = exports.COMBO_BOX_ACCESSIBILITY_KEY_SET = exports.SELECT_ACCESSIBILITY_KEY_SET = exports.TABS_ACCESSIBILITY_KEY_SET = exports.OVERLAY_ACCESSIBILITY_KEY_SET = exports.DROPDOWN_ACCESSIBILITY_KEY_SET = exports.POSITIONS = void 0;
exports.POSITIONS = {
    auto: 'auto',
    'auto-start': 'auto-start',
    'auto-end': 'auto-end',
    top: 'top',
    'top-left': 'top-start',
    'top-right': 'top-end',
    bottom: 'bottom',
    'bottom-left': 'bottom-start',
    'bottom-right': 'bottom-end',
    right: 'right',
    'right-start': 'right-start',
    'right-end': 'right-end',
    left: 'left',
    'left-start': 'left-start',
    'left-end': 'left-end',
};
exports.DROPDOWN_ACCESSIBILITY_KEY_SET = [
    'Escape',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'Enter',
];
exports.OVERLAY_ACCESSIBILITY_KEY_SET = ['Escape', 'Tab'];
exports.TABS_ACCESSIBILITY_KEY_SET = [
    'ArrowUp',
    'ArrowLeft',
    'ArrowDown',
    'ArrowRight',
    'Home',
    'End',
];
exports.SELECT_ACCESSIBILITY_KEY_SET = [
    'ArrowUp',
    'ArrowLeft',
    'ArrowDown',
    'ArrowRight',
    'Home',
    'End',
    'Escape',
    'Enter',
    'Tab',
];
exports.COMBO_BOX_ACCESSIBILITY_KEY_SET = [
    'ArrowUp',
    'ArrowLeft',
    'ArrowDown',
    'ArrowRight',
    'Home',
    'End',
    'Escape',
    'Enter',
];
exports.BREAKPOINTS = {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};
